function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M75.1222 34.1898H69.5737C68.367 34.1898 67.2195 34.7695 66.5097 35.7632L47.9124 61.5534L39.4891 49.865C38.7793 48.8831 37.6436 48.2916 36.4251 48.2916H30.8766C30.1077 48.2916 29.6581 49.167 30.1077 49.794L44.8483 70.2369C45.1965 70.7229 45.6556 71.119 46.1874 71.3922C46.7192 71.6654 47.3085 71.8079 47.9064 71.8079C48.5043 71.8079 49.0936 71.6654 49.6255 71.3922C50.1573 71.119 50.6164 70.7229 50.9646 70.2369L75.8793 35.6923C76.3407 35.0653 75.8911 34.1898 75.1222 34.1898Z",
  fill: "#F7A512"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53 0C23.7317 0 0 23.7317 0 53C0 82.2683 23.7317 106 53 106C82.2683 106 106 82.2683 106 53C106 23.7317 82.2683 0 53 0ZM53 97.0089C28.7004 97.0089 8.99107 77.2996 8.99107 53C8.99107 28.7004 28.7004 8.99107 53 8.99107C77.2996 8.99107 97.0089 28.7004 97.0089 53C97.0089 77.2996 77.2996 97.0089 53 97.0089Z",
  fill: "#F7A512"
});

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.1c6472a7.svg";
export { ForwardRef as ReactComponent };